export const actions = {
  GET_WORK_EXPERIENCE_REQUEST: "GET_WORK_EXPERIENCE_REQUEST",
  GET_WORK_EXPERIENCE_SUCCESS: "GET_WORK_EXPERIENCE_SUCCESS",

  CREATE_WORK_EXPERIENCE_REQUEST: "CREATE_WORK_EXPERIENCE_REQUEST",
  CREATE_WORK_EXPERIENCE_SUCCESS: "CREATE_WORK_EXPERIENCE_SUCCESS",

  UPDATE_WORK_EXPERIENCE_REQUEST: "UPDATE_WORK_EXPERIENCE_REQUEST",
  UPDATE_WORK_EXPERIENCE_SUCCESS: "UPDATE_WORK_EXPERIENCE_SUCCESS",

  GET_WORK_EXPERIENCE_TILES_REQUEST: "GET_WORK_EXPERIENCE_TILES_REQUEST",
  GET_WORK_EXPERIENCE_TILES_SUCCESS: "GET_WORK_EXPERIENCE_TILES_SUCCESS",

  // ORGANIZATION WORK EXPERIENCE ACTIONS
  GET_ORG_WORK_EXPERIENCE_REQUEST: "GET_ORG_WORK_EXPERIENCE_REQUEST",
  GET_ORG_WORK_EXPERIENCE_SUCCESS: "GET_ORG_WORK_EXPERIENCE_SUCCESS",
  SET_ORG_WORK_EXPERIENCE_LOADING: "SET_ORG_WORK_EXPERIENCE_LOADING",
  SET_LOADING_PROGRESS: "SET_LOADING_PROGRESS", // NEW
  DOWNLOAD_WORK_EXPERIENCE_CSV: "DOWNLOAD_WORK_EXPERIENCE_CSV",

  CATCH_ERROR: "CATCH_ERROR",

  getWorkExperience: (data, navigate) => {
    return {
      type: actions.GET_WORK_EXPERIENCE_REQUEST,
      data,
      navigate,
    };
  },

  createWorkExperience: (data) => {
    return {
      type: actions.CREATE_WORK_EXPERIENCE_REQUEST,
      data,
    };
  },

  getWorkExperienceTiles: (data) => {
    return {
      type: actions.GET_WORK_EXPERIENCE_TILES_REQUEST,
      data,
    };
  },

  updateWorkExperience: (data) => {
    return {
      type: actions.UPDATE_WORK_EXPERIENCE_REQUEST,
      data,
    };
  },

  // ORGANIZATION WORK EXPERIENCE ACTION CREATORS
  getOrgWorkExperience: (clubId) => {
    return {
      type: actions.GET_ORG_WORK_EXPERIENCE_REQUEST,
      clubId: clubId,
    };
  },

  downloadWorkExperienceCSV: () => {
    return {
      type: actions.DOWNLOAD_WORK_EXPERIENCE_CSV,
    };
  },

  setOrgWorkExperienceLoading: (loading) => {
    return {
      type: actions.SET_ORG_WORK_EXPERIENCE_LOADING,
      payload: loading,
    };
  },

  // NEW ACTION CREATOR FOR PROGRESS
  setLoadingProgress: (progress) => {
    return {
      type: actions.SET_LOADING_PROGRESS,
      payload: progress,
    };
  },
};